module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/dashboard'
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.dashboard')) + "\n                ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('pages.statistic')) + "\n            ")]), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.CONVERSIONS)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/country'
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.conversions')) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.WEBMASTERS) || _vm.haveAccess(_vm.Config.STATISTICS.WEBMASTERS_PAYMENTS)) ? _c('router-link', {
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": '/statistic/webmasters',
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fa fa-internet-explorer"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.webmasters')) + "\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [(_vm.haveAccess(_vm.Config.STATISTICS.WEBMASTERS)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.webmaster_statistic')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.WEBMASTERS_PAYMENTS)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters/payments',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-columns icons-big"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title-big"
  }, [_vm._v(_vm._s(_vm.$t('pages.individual_rates')))])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters/source',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-columns icons-big"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title-big"
  }, [_vm._v(_vm._s(_vm.$t('pages.source_statistic')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters/landing',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-columns icons-big"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title-big"
  }, [_vm._v(_vm._s(_vm.$t('pages.landing_statistic')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters/arrival_new_leads\n',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-columns icons-big"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title-big"
  }, [_vm._v(_vm._s(_vm.$t('pages.arrival_new_leads')))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters/grid',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-columns icons-big"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title-big"
  }, [_vm._v(_vm._s(_vm.$t('pages.grid_statistic')))])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.OFFER_RENTABILITY)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/offer'
    }
  }, [_c('i', {
    staticClass: "fa fa-percent"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.offer')) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.RETURN_REASON)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/refunds'
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.refunds')) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.BUYOUT)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/buyout'
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.buyout')) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.OPERATORS_EFFICIENCY) || _vm.haveAccess(_vm.Config.STATISTICS.OPERATORS_ACTIVITY) || _vm.haveAccess(_vm.Config.STATISTICS.ORDER_PROCESSING)) ? _c('router-link', {
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": '/statistic/operators',
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.operators')) + "\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [(_vm.haveAccess(_vm.Config.STATISTICS.OPERATORS_EFFICIENCY)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/efficiency',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-bolt"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.efficiency')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.OPERATORS_ACTIVITY)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/activity',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.activity')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.ORDER_PROCESSING)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/order',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-cube"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.order')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.OPERATORS_SUMMARY)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/conversions/conversion',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.conversion')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.OFFER_ACTIVITY_STATISTIC)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/schedule',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.approved_during_the_day')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.EXPENSE_EXPECTION)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/expenses_kc',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.expenses_by_kc')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.CALL_CENTER_TIMINGS)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/timing_kc',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.timing_kc')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.EXPENSE_EXPECTION)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/ringing_sms',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.ringing_sms')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/call_statistics',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.call_statistics')) + "\n                        ")])], 1), _vm._v(" "), (_vm.haveAccess(_vm.Config.STATISTICS.HOLD_CALLS)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/ringing_holds',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.ringing_holds')) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/cross_sell',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-cube"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.cross_sell')) + "\n                    ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/product'
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('pages.product')) + "\n                ")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b544cdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 511
// module chunks = 0